<template>
  <v-container container--fluid fill-height style="background: #e6e6fc;">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6" md="6" lg="5" xl="5">
        <v-stepper
          v-model="st"
          class="ra-2"
          style="
                    border-top: 5px solid #7f79d9;
                    border-bottom: 5px solid #7f79d9;
                    box-shadow: 0px 0px 27px 5px rgba(2, 2, 2, 0.096) ;
              "
        >
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card text class="pa-5 elevation-0">
                <div>
                  <v-img
                    height="60"
                    contain
                    src="https://cdn.siap.id/s3/Posgram/aset/favicon.svg"
                    aspect-ratio="1"
                  ></v-img>
                </div>
                <v-card-title primary-title class="justify-space-around">
                  <span class="title primary--text d-block text-center font-weight-bold">AKTIVASI POSGRAM</span>
                </v-card-title>
                <v-card-text>
                  <v-form data-vv-scope="form-aktivasi" lazy-validation>
                    <v-row column wrap>
                      <v-col cols="12" class="text-center items-center">
                        <v-img
                          src="https://cdn.siap.id/s3/Posgram/Respon-OTP.png"
                          style="width: 200px; margin: 0 auto;"
                        />
                        <p class="justify-space-around black--text caption mb-0">
                          Kode token di bawah ini adalah hasil generate dari Layanan Posgram. Sehingga akan terisi
                          otomatis. Jika kode token di bawah ini belum muncul. Silakan cek email Anda, karena kode token
                          telah dikirimkan ke surel/email valid Anda. Kemudian inputkan kode token dalam kolom di bawah.
                          Untuk lanjut proses integrasi, silakan klik tombol <b>AKTIFKAN</b>
                        </p>

                        <v-alert v-if="errorToken" dense type="error" text class="text-left mt-2">
                          Jika Anda dari instansi Madrasah Naungan Simpatika. Dan ingin melakukan aktivasi Instansi.
                          Silakan ikuti
                          <a
                            href="https://bantuan.masook.id/masook/panduan-sim-masook-operator-simpatika/ch08/8-1-aktivasi-kode.html"
                            >panduan berikut ini!</a
                          >
                        </v-alert>
                      </v-col>
                      <v-col cols="12">
                        <span>Kode Token</span>
                        <v-text-field
                          label="Kode Token"
                          v-model="token"
                          v-mask="'####-####'"
                          hint="Silakan masukkan kode token Anda*"
                          outlined
                          dense
                          single-line
                          data-vv-name="token"
                          data-vv-as="Kode Token"
                          v-validate="'required'"
                          :error-messages="errors.collect('form-aktivasi.token')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="justify-space-around text-center">
                        <v-btn :loading="loading" depressed large color="primary" @click="aktivasi">AKTIFKAN</v-btn>
                        <router-link class="ok" :to="{ name: 'login' }">
                          <p class="mt-4">Kembali ke halaman Login</p>
                        </router-link>
                      </v-col>
                      <br />
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card textclass="pa-5">
                <div class>
                  <v-img
                    height="60"
                    contain
                    src="https://cdn.siap.id/s3/masook/asset img/SIM/logo.png"
                    aspect-ratio="1"
                  ></v-img>
                </div>
                <v-card-title primary-title class="justify-space-around">
                  <span class="title primary--text d-block text-center">Konfirmasi Data Posgram</span>
                </v-card-title>
                <v-card-text>
                  <v-img v-if="user.url" :src="user.url" style="width: 100px; margin: 0 auto;" />
                  <v-sheet rounded="lg" class="pa-4 mb-6 mt-5 grey lighten-4" outlined style="border-color: #7d7bd3">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <div class="text-caption text-medium-emphasis">Nama</div>
                        <div class="text-subtitle-1">{{ user.nama }}</div>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <div class="text-caption text-medium-emphasis">Email</div>
                        <div class="text-subtitle-1">{{ user.email }}</div>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <div class="text-caption text-medium-emphasis">No. Telepon</div>
                        <div class="text-subtitle-1">{{ user.no_telp }}</div>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <div class="text-caption text-medium-emphasis">Alamat</div>
                        <div class="text-subtitle-1">{{ user.alamat }}</div>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-card-text>
                <v-card-actions>
                  <v-btn class="mb-5" width="50%" depressed outlined color="primary" @click="st = 1">
                    Kembali
                  </v-btn>
                  <v-btn class="mb-5" width="50%" disabled :loading="loading" depressed color="primary" @click="setPassword">
                    Aktivasi
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-dialog persistent v-model="dialog" width="550">
                <v-card
                  class="pa-5"
                  style="
                    border-top: 5px solid #7f79d9;
                    border-bottom: 5px solid #7f79d9;
              "
                >
                  <div class>
                    <v-img
                      height="60"
                      contain
                      src="https://cdn.siap.id/s3/masook/asset img/SIM/logo.png"
                      aspect-ratio="1"
                    ></v-img>
                  </div>
                  <v-card-title primary-title class="justify-space-around">
                    <span class="title primary--text d-block text-center font-weight-bold">Berhasil</span>
                  </v-card-title>
                  <v-card-text class="black--text text-center">
                    <div v-if="is_perpanjang">
                      <p class="mt-4 pt-4 caption">
                        Proses aktivasi layanan Masook Anda berhasil.
                      </p>
                      <v-alert color="grey lighten-2 caption">
                        Silakan akses Layanan Masook Simpatika, melalui tautan berikut
                      </v-alert>
                      <p>Terima kasih</p>
                    </div>
                    <div v-else-if="is_sso">
                      <img src="https://cdn.siap.id/s3/masook/asset%20img/SIM/ak-instansi.png" width="50%" />
                      <p class="mt-4 pt-4 caption">
                        Proses aktivasi layanan Masook Anda berhasil. Silakan untuk dapat login dengan akun yang Anda
                        dapat.
                      </p>
                      <p />
                      <v-alert color="grey lighten-2 caption">
                        Khusus untuk layanan Masook integrasi Simpatika. Silakan akses Layanan Simpatika Anda, dan
                        aktifkan Konfirmasi Authorized untuk singkron data Simpatika dengan layanan Masook.
                        <ol>
                          <li>
                            Silakan Akses layanan Instansi Simpatika anda pada
                            <a href="https://simpatika.kemenag.go.id/#!/login"
                              >https://simpatika.kemenag.go.id/#!/login</a
                            >
                          </li>
                          <li>
                            Pada Menu Abesensi instansi Anda, tekan tombol "Autorize" untuk melakukan proses
                            sinkronisasi data Simpatika dengan layanan Masook
                          </li>
                        </ol>
                      </v-alert>
                      <p>Terima kasih</p>
                    </div>
                    <div v-else>
                      <p class="mt-4 pt-4 caption">
                        Proses aktivasi layanan Masook Anda berhasil.
                      </p>
                      <v-alert color="grey lighten-2 caption">
                        Silakan akses Layanan BI Masook Simpatika, melalui tautan berikut
                        <a href="https://simpatika.kemenag.go.id/laporan/">https://simpatika.kemenag.go.id/laporan/</a>
                      </v-alert>
                      <p>Terima kasih</p>
                      <p />
                    </div>
                    <router-link class="ok" :to="{ name: 'login' }">
                      <p class="mt-4">Kembali ke halaman Login</p>
                    </router-link>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mask } from 'vue-the-mask'
import VueRecaptcha from 'vue-recaptcha'
export default {
  components: { VueRecaptcha },
  $_veeValidate: {
    validator: 'new',
  },
  directives: {
    mask,
  },
  data() {
    return {
      st: 1,
      dialog: false,
      user: {},
      appendIcon: 'mdi-eye-off',
      passwordFieldType: 'password',
      token: '',
      password: null,
      password_confirmation: null,
      loading: false,
      is_sso: null,
      is_perpanjang: null,
      errorToken: false,
    }
  },
  activated() {
    this.user = {}
    this.dialog = false
    this.is_sso = false
  },
  mounted() {
    this.checkQuery()
  },
  methods: {
    checkQuery() {
      if (this.$route.query.token) {
        this.token = this.$route.query.token
        // clean query
        // langsung lakukan verifikasi
        this.$nextTick(() => {
          if (this.$router.query.check) {
            this.aktivasi()
          }
        })
      }
    },
    // eslint-disable-next-line
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
      this.passwordFieldType === 'password' ? (this.appendIcon = 'mdi-eye-off') : (this.appendIcon = 'mdi-eye')
    },
    toLogin() {
      this.dialog = false
      this.$router.push({
        name: 'login',
      })
    },
    aktivasi() {
      this.errorToken = false
      const regex = /^[0-9a-zA-Z]+$/
      if ([10, 40].includes(this.token.length) && this.token.match(regex)) {
        this.errorToken = true
        return
      }

      this.$validator
        .validateAll('form-aktivasi')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          return this.$store
            .dispatch('user/cekTokenPosgram', {
              token: this.token,
            })
            .then(({ data }) => {
              this.user = data
              this.st = 2
              return data
            })
            .catch((e) => e)
        })
        .catch((e) => e)
    },
    setPassword() {
      this.$validator
        .validateAll('form-sandi')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          return this.$store
            .dispatch('user/setPassword', {
              pass: this.password,
              password_confirm: this.password_confirmation,
              token: this.user.token,
            })
            .then((res) => {
              this.st = 3
              this.dialog = true
              return res
            })
            .catch((e) => e)
        })

        .catch((e) => e)
    },

    setAktivasi(params) {
      this.$store.dispatch('user/setAktivasi', params).then((res) => {
        if (params.is_simpatika === true) {
          this.$router.push({ name: 'user.aktivasi-simpatika', params: { token: this.token } })
        } else {
          if ([2, 3].includes((res.data && res.data.pesanan && res.data.pesanan.k_jenis_pesanan) || 1)) {
            this.is_perpanjang = true
            this.dialog = true
            this.st = 3
          } else if (res.data.is_sso === 0) {
            this.st = 2
            this.is_sso = false
          } else {
            this.is_sso = true
            this.dialog = true
            this.st = 3
          }
        }
      })
    },
  },
}
</script>
